import { confirm as confirmFunction } from "../libs/confirm"
export const confirm = {
  mounted(el: any, binding: any) {
    el.addEventListener("click", function (e: any) {
      e.preventDefault()
      e.stopPropagation()
      const { message, handler, params } = binding.value
      confirmFunction({
        text: message,
      }).then((confirmed) => {
        if (confirmed) {
          if (handler) {
            handler(...params, el)
          } else if (el.tagName.toLowerCase() === "a") {
            const a = document.createElement("a")
            a.href = el.href
            for (let name in el.dataset) {
              a.dataset[name] = el.dataset[name]
            }
            a.style.opacity = "0"
            a.style.width = "0"
            a.style.height = "0"
            a.style.overflow = "none"
            document.body.appendChild(a)
            a.click()
            a.remove()
          }
        }
      })
    })
  },
}
